/**
 * Generates legend labels in the format needed
 * by the library. Works only for pie charts.
 *
 * @param {Object} chart Chart.js instance
 * @return {Array} array of legend items
 */
module.exports = chart => {
  const data = chart.data
  if (data.labels.length && data.datasets.length) {
    return data.labels.map((label, i) => {
      const ds = data.datasets[0]
      return {
        text: `${label} (${ds.data[i]}%)`,
        fillStyle: ds.backgroundColor[i],
        lineWidth: 0
      }
    })
  }
  return []
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/helpers/generate_labels.js